import useQueryParams from '@common/src/hooks/useQueryParams';
import { useAnvaFlowsInsuranceTags } from '@flows/src/api/anva-flows/getAnvaFlowsInsuranceTags';
import { PartyType } from '@parties/src/types';

interface InsuranceNameResponse {
  insuranceName: string;
  getInsuranceName: (insuranceId: number) => string;
}

const useAnvaInsuranceGroupName = (
  insuranceId?: string,
): InsuranceNameResponse => {
  const queryparams = useQueryParams();
  const partyType = (queryparams.get('type') as PartyType) || 'CUSTOMER';
  const { data: insuranceData } = useAnvaFlowsInsuranceTags(partyType);
  const insuranceName = insuranceData?.items.find(
    (insurance) => insurance.id === Number(insuranceId),
  )?.name;

  const getInsuranceName = (id: number) => {
    return (
      insuranceData?.items.find((insurance) => insurance.id === id)?.name || ''
    );
  };
  return {
    insuranceName: insuranceName || '',
    getInsuranceName,
  };
};

export default useAnvaInsuranceGroupName;
